import React from 'react';
import { Card, Input } from '@avila-tek/ui/src';
import LoadingButton from '../shared/LoadingButton';

interface CouponInputProps {
  promoCode: string;
  setPromoCode: React.Dispatch<React.SetStateAction<string>>;
  handleApplyPromoCode: () => void;
  loading: boolean;
}

function CouponInput({
  promoCode,
  setPromoCode,
  handleApplyPromoCode,
  loading,
}: CouponInputProps) {
  return (
    <Card className="p-4 px-6 ">
      <h3 className="text-purple-300 font-semibold text-lg  uppercase my-2">
        Cupón de descuento
      </h3>
      <hr className="mb-3" />

      <div className="w-full flex gap-5 py-5 ">
        <div className="w-full">
          <Input
            value={promoCode}
            onChange={(e) => {
              e.preventDefault();
              setPromoCode(e.target.value);
            }}
            placeholder="Ingrese cúpon"
          />
        </div>
        <div className="w-14">
          <LoadingButton
            className="ml-auto"
            onClick={handleApplyPromoCode}
            loading={loading}
            text="+"
          />
        </div>
      </div>
    </Card>
  );
}

export default CouponInput;
